import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { base_url } from '../../Utils/baseUrl';
import { config } from '../../Utils/axiosconfig';
import AddChild from '../ProfileModals/addchild';
import EditChild from '../ProfileModals/editchild';
import DeleteConfirmationModal from '../Common/Modal/DeleteConfirmationModal';
import DefaultPagination from "../../config/Pagination";
import { fetchChild } from '../../app/child/childSlice';
import commonFunction from '../../Utils/commonFunction';
import Pagination from '.././Common/Pagination';

function UserChild({ addChild }) {
    const [school, setSchool] = useState();
    const [classes, setClasses] = useState();
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [childId, setChildId] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [childToDelete, setChildToDelete] = useState(null);

    const dispatch = useDispatch();

    // Use state to manage userData
    const [userData, setUserData] = useState({
        search: '',
        pageSize: DefaultPagination.PAGE_SIZE,
        pageNumber: DefaultPagination.PAGE_NUMBER,
    });

    const paginationWithPage = (pageNumber) => {
        // showChildData.pageNumber = pageNumber;
        setUserData((prevUserData) => ({ ...prevUserData, pageNumber: pageNumber }));
        dispatch(fetchChild(userData));
    };

    const child = useSelector((state) => state.child);
    const closeaddModal = () => setIsAddModalOpen(false);
    const closeModal = () => setIsModalOpen(false);

    const openAddModal = () => {
        setIsAddModalOpen(true);
    }

    const openModal = (id) => {
        setChildId(id);
        setIsModalOpen(true);
    }

    useEffect(() => {
        if (!school) {
            const schools = commonFunction.getSchools();
            schools.then((res) => {
                setSchool(res.data);
            })
        }
        if (!classes) {
            const schoolClass = commonFunction.fetchData('getSchoolClass');
            schoolClass.then((res) => {
                setClasses(res);
            })
        }
        dispatch(fetchChild(userData));

        window.scrollTo(0, 0)
        // eslint-disable-next-line
    }, [userData, school, classes]);

    const openDeleteModal = (childId) => {
        const targetChild = child?.getchild?.data?.child?.find(c => c.id === childId);
        if (!targetChild) {
            toast.error('Child not found');
            return;
        }
        setChildToDelete(targetChild);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setChildToDelete(null);
    };

    const handleConfirmDelete = async () => {
        if (!childToDelete?.id) return;
        try {
            const res = await axios.get(`${base_url}deleteChild/${childToDelete.id}`, config);
            toast.success(res?.data?.message || 'Barnet er blevet slettet');
            dispatch(fetchChild(userData));
        } catch (error) {
            console.error('An error occurred while deleting the child:', error);
            toast.error('Please wait!! Something went wrong !!');
        } finally {
            closeDeleteModal();
        }
    };

    return (
        <div
            className={addChild ? "tab-pane fade show active" : "tab-pane fade"}
            id="child"
            role="tabpanel"
            aria-labelledby="child-tab"
        >
            <div className="tab_innerBody">
                <div className="tab_innerBodyTitle">
                    <h4>Mine Børn</h4>
                </div>
                <div className="tab_subItems">
                    <div className="tab_tableItem">
                        <div className="text-right mb-3">
                            <button className='btn btn-secondary' onClick={() => { openAddModal() }} >Opret Barn</button>
                        </div>
                        <table className="table table-striped text-center">
                            <thead>
                                <tr>
                                    <th scope="col">Fulde Navn</th>
                                    <th scope="col">Skole</th>
                                    <th scope="col">Klasse</th>
                                    <th scope="col" className="text-right">
                                        Handling
                                    </th>
                                </tr>
                                {(child?.getchild?.data?.child != undefined && child?.getchild?.data?.child.length > 0) ?
                                    child?.getchild?.data?.child?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item?.name}</td>
                                            <td>{item?.School?.schoolName}</td>
                                            <td>{item?.SchoolClass?.className}</td>
                                            <td>
                                                {/* <Link to={''} >Edit</Link> */}
                                                <i className="fa fa-pen" data-bs-toggle="tooltip" title="Rediger" onClick={() => { openModal(item.id) }} style={{ cursor: 'pointer', }}></i>
                                                &nbsp;
                                                |
                                                &nbsp;
                                                <i className="fa fa-trash" data-bs-toggle="tooltip" title="Slet" onClick={() => { openDeleteModal(item.id) }} style={{ cursor: 'pointer' }}></i>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <tr>
                                        <td colSpan={9}>No order found !!</td>
                                    </tr>
                                }
                            </thead>
                        </table>
                    </div>
                    {/* Pagination component */}
                    <Pagination
                        totalPage={child?.getchild?.data?.pagination?.totalPages}
                        currentPage={child?.getchild?.data?.pagination?.currentPage}
                        fullPagination={paginationWithPage}
                    />
                </div>
            </div>
            <AddChild
                isAddOpen={isAddModalOpen}
                closeaddModal={closeaddModal}
                school={school}
                classes={classes}
            />
            <EditChild
                isOpen={isModalOpen}
                closeModal={closeModal}
                childId={childId}
                school={school}
                classes={classes}
                userData={userData}
            />
            <DeleteConfirmationModal
                isOpen={isDeleteModalOpen}
                onClose={closeDeleteModal}
                onConfirm={handleConfirmDelete}
                childName={childToDelete?.name}
            />
        </div>
    )
}

export default UserChild